import React from 'react';

import {COMPANY_TYPES} from 'configs';
import {getPublicBranchesByAb, getPublicBranchesByCb} from 'api/branches';
import {queryStringify} from 'utils/http';
import {getCountryNameById} from 'utils/locales';
import {SelectAsyncBase} from 'components/Forms/FormBases';

SelectBranch.defaultProps = {
  companyType: COMPANY_TYPES.ab,
};

function SelectBranch(props) {
  function loadOptions(inputValue) {
    const queries = queryStringify({
      search: inputValue,
      limit: -1, // Unlimited list
      company_status: 'active',
      order: 'ASC',
      order_by: 'company_name',
    });

    const {companyType, id} = props;

    let handler;

    if (companyType === COMPANY_TYPES.ab) {
      handler = getPublicBranchesByAb;
    } else {
      handler = getPublicBranchesByCb;
    }

    return handler(id, queries).then(({data}) => {
      return data;
    });
  }

  function getOptionLabel(option) {
    const {countries_id, company_name} = option;

    return (
      <div>
        {company_name}
        <span className="ml-1 text-muted small">
          {getCountryNameById(countries_id)}
        </span>
      </div>
    );
  }

  const {value, ...rest} = props;

  return (
    <SelectAsyncBase
      cacheOptions
      defaultOptions
      name="company_id"
      defaultValue={value}
      loadOptions={loadOptions}
      getOptionLabel={getOptionLabel}
      getOptionValue={(option) => option.company_id}
      placeholder="Select Branch"
      {...rest}
    />
  );
}

export default SelectBranch;
